"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionsService = void 0;
var http_1 = require("@/utils/http");
var logger_1 = require("../../utils/logger");
var SESSION_KEY = 'fss.sessionToken';
function getToken() {
    return __awaiter(this, void 0, Promise, function () {
        var token, isTokenValid, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    token = localStorage.getItem(SESSION_KEY);
                    logger_1.logger.log('Verifying token.');
                    if (!token) return [3 /*break*/, 2];
                    return [4 /*yield*/, verifyToken(token)];
                case 1:
                    _a = _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _a = false;
                    _b.label = 3;
                case 3:
                    isTokenValid = _a;
                    // Don't do anything when token is still valid
                    if (isTokenValid) {
                        logger_1.logger.log('Existing token is valid.');
                        return [2 /*return*/, undefined];
                    }
                    // Get a new token
                    logger_1.logger.log('Token is not valid. Fetching a new one');
                    return [4 /*yield*/, fetchToken()];
                case 4:
                    token = _b.sent();
                    // Persist token
                    storeToken(token);
                    logger_1.logger.log('New token was persisted');
                    return [2 /*return*/];
            }
        });
    });
}
/**
 * verifyToken: used to verify token stored in the localStorage
 */
function verifyToken(tokenId) {
    return __awaiter(this, void 0, Promise, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, http_1.httpClient.get('/sessions/verify', { params: { tokenId: tokenId } })];
                case 1:
                    _a.sent();
                    return [2 /*return*/, true];
                case 2:
                    error_1 = _a.sent();
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    });
}
/**
 * fetchToken: retrieve a new token when no token was previously stored or the one found is invalid
 */
function fetchToken() {
    return __awaiter(this, void 0, Promise, function () {
        var data, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, http_1.httpClient.post('/sessions')];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data.token];
                case 2:
                    error_2 = _a.sent();
                    throw new Error('Unable to fetch session token');
                case 3: return [2 /*return*/];
            }
        });
    });
}
function storeToken(token) {
    localStorage.setItem(SESSION_KEY, token);
}
exports.SessionsService = { getToken: getToken };
